// extracted by mini-css-extract-plugin
export default {"galleryContainer":"styles_galleryContainer__sYXgm","gradfacesContainer":"styles_gradfacesContainer__9v6sl","gradfacesIcon":"styles_gradfacesIcon__HA97O"};